import { createStyles } from "@mantine/core";

export default createStyles((theme) => ({
  container: {
    padding: theme.spacing.md,
    height: "100%",
  },
  scrollArea: {
    height: "calc(100vh - 140px)",
  },
  dateHeader: {
    fontSize: theme.fontSizes.lg,
    fontWeight: 600,
    marginBottom: theme.spacing.md,
  },
  tripCard: {
    marginBottom: theme.spacing.sm,
    backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.white,
    position: "relative",
    overflow: "hidden",
    "&.completed": {
      backgroundColor: theme.fn.rgba(theme.colors.green[7], 0.05),
    },
    "&.cancelled": {
      backgroundColor: theme.fn.rgba(theme.colors.red[7], 0.05),
    },
    "&.started": {
      backgroundColor: theme.fn.rgba(theme.colors.blue[7], 0.05),
    },
    "&.waiting": {
      backgroundColor: theme.fn.rgba(theme.colors.yellow[7], 0.05),
    },
    "&.scheduled": {
      backgroundColor: theme.fn.rgba(theme.colors.grape[7], 0.05),
    },
  },
  tripHeader: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing.sm,
  },
  tripIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 40,
    height: 40,
    borderRadius: theme.radius.sm,
    backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[5] : theme.colors.gray[0],
  },
  status: {
    position: "absolute",
    top: 0,
    right: 0,
    padding: "4px 12px",
    borderRadius: "0 0 0 4px",
    fontWeight: 500,
    fontSize: theme.fontSizes.sm,
    "&.completed": {
      backgroundColor: theme.colors.green[7],
      color: theme.white,
    },
    "&.cancelled": {
      backgroundColor: theme.colors.red[7],
      color: theme.white,
    },
    "&.started": {
      backgroundColor: theme.colors.blue[7],
      color: theme.white,
    },
    "&.waiting": {
      backgroundColor: theme.colors.yellow[7],
      color: theme.white,
    },
    "&.scheduled": {
      backgroundColor: theme.colors.grape[7],
      color: theme.white,
    },
  },
  loadingContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
  },
  errorContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
  },
}));
